module.exports = __webpack_public_path__ + "img/7.e707bbeb.jpg";